module.exports = __webpack_public_path__ + "img/linkedin.a83df158.jpg";